import { ShortcutProduct } from '@common/types/GraphqlTypes.d';

/**
 * Removed products with quantity 0.
 */
export const filterZeroQuantityProducts = (products: ShortcutProduct[]) =>
  products.filter((product) => product.quantity > 0);
